// Merkan · Adresse /support: öffnet das Fenster „Frage an den Support“ und kehrt zur vorherigen Seite zurück.
// Hugo verlinkt hierher, wenn ein Benutzer eine Funktion nicht nutzen darf (/support?frage=…). So bleibt der Link
// stabil, auch wenn das Supportformular später eine eigene Seite bekommt.
import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supportOeffnen } from '../seiten/benachrichtigungen/SupportDialog';

export default function SupportLink() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const erledigt = useRef(false);
  useEffect(() => {
    if (erledigt.current) return;
    erledigt.current = true;
    const frage = params.get('frage')?.slice(0, 2000) || undefined;
    // Erst zurück, dann öffnen: das Fenster hängt am Rahmen und bleibt beim Seitenwechsel offen
    const vorher = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (vorher > 0) navigate(-1); else navigate('/', { replace: true });
    window.setTimeout(() => supportOeffnen({ quelle: 'hugo', frage }), 0);
  }, [navigate, params]);
  return null;
}
